/**
 * 상세 섹션 4건 — 시안(2828:1982 · 2828:2110 · 2828:2172 · 2828:2198) 기준
 *
 * 시안에 상세 섹션이 있는 에이전트만 담는다. 물량계산기·견적작성기·캘린더는
 * 시안에서 빠졌으므로 상세를 만들지 않는다 — 존재는 StudioSection 이미지가 알린다.
 *
 * 카피는 시안 텍스트를 그대로 옮겼다(구 FEATURES 배열의 문구와 미세하게 다르다).
 */
export interface Feature {
  /** 히어로의 "에이전트 둘러보기" 등에서 앵커로 쓴다 */
  id: string;
  /** 섹션 상단 카테고리 라벨 */
  kicker: string;
  /** 헤드라인 — 배열 1항목이 시안의 한 줄 */
  headline: string[];
  /** 회색 카드 — 지금의 불편 */
  before: string;
  /** 파란 카드 — 바뀌는 점 */
  after: string;
  image: { src: string; alt: string };
  /** true면 이미지가 왼쪽 (시안의 좌우 교대) */
  reverse: boolean;
  /**
   * 섹션 배경. 시안에서 indiphotoSection 프레임(인디포토·인디공사현황)만 옅은 회색이다.
   * reverse와 값이 우연히 겹치지만 별개 축이라 따로 둔다.
   */
  background: 'white' | 'gray';
}

export const FEATURES: Feature[] = [
  {
    id: 'studio',
    kicker: '인디피아 스튜디오',
    headline: ['사장님만의 스튜디오!', '온라인 작업공간을 가져 보세요'],
    before:
      '현장·자재·일정이 각기 다른 곳에 흩어져 있습니다. 오프라인 사무실, 벽걸, 카카오톡을 오가며 하루가 지나갑니다.',
    after:
      '스튜디오에 사장님의 에이전트를 등록하세요. 현장·고객·자재·시공사를 등록하면 에이전트와 연결됩니다. 지금까지 하던 일을 더 쉽게 스튜디오 한 곳에서 다 해보세요.',
    image: { src: '/landing/feature-studio.png', alt: '인디피아 스튜디오 화면' },
    reverse: false,
    background: 'white',
  },
  {
    id: 'photo',
    kicker: '인디포토',
    headline: ['현장사진,', '이제는 찍으면 알아서 정리됩니다'],
    before:
      '핸드폰에 현장 사진이 수백 장 쌓여 있습니다. 어느 현장 사진인지 찾으려면 매번 한참 스크롤해야 합니다.',
    after:
      '사진을 등록하면 찍은 위치를 인식해서 현장별로 자동으로 분류됩니다. 고객에게 보낼 땐 원하는 것만 골라 바로 공유하세요',
    image: { src: '/landing/feature-photo.png', alt: '인디포토 현장 사진 정리 화면' },
    reverse: true,
    background: 'gray',
  },
  {
    id: 'scheduler',
    kicker: '인디공사 스케줄',
    headline: ['엑셀 견적서로 공정표를 자동으로 만들고, 효율적으로 마감일을 관리해 보세요'],
    before:
      '견적서 보고 공정표 만들고, 작업자마다 전화 돌리고, 자재 납품일 확인하고, 또 일정 다시 맞추고. 착공도 못 했는데 반나절이 사라집니다. 날짜 하나 바뀌면, 다시 처음부터입니다.',
    after:
      '견적서 파일 하나 올리면 공정표가 바로 완성됩니다. 작업자를 배정하면 확인 톡이 자동 발송되고, 답장이 오면 바로 확인할수 있습니다. 자재 발주 사전 알람으로 납품 지연을 미리 잡아, 공사가 예정대로 마무리됩니다.',
    image: { src: '/landing/feature-schedule.png', alt: '인디공사 스케줄 공정표 화면' },
    reverse: false,
    background: 'white',
  },
  {
    id: 'work-log',
    kicker: '인디공사현황',
    headline: ['현장에서 일어나는', '모든것을 한곳에서 끝냅니다'],
    before:
      '작업자에게 카카오·문자로 따로 지시하고, 현장 보고는 또 따로 받고, 공사일지는 밤에 엑셀로 직접 정리하고. 현장이 2개만 넘어도 하루가 사라집니다.',
    after:
      '작업지시 등록하면 확인 톡이 자동 발송되고, 공사현황에 바로 반영되어 확인할수 있습니다. 현장에 가지 않고도 현장사진점검, 현장보고, 공사일지로 현장을 관리합니다.',
    image: { src: '/landing/feature-worklog.png', alt: '인디공사현황 화면' },
    reverse: true,
    background: 'gray',
  },
];
